import { Palette } from 'config';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 8px;
  background-color: ${Palette.PrimaryGray._000};
  box-shadow: inset 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  border: ${({ showErrorBorder }) => showErrorBorder && `1px solid ${Palette.Red._300}`};
  margin-bottom: 5px;
`;
export const BtnWrap = styled.div`
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 16px;
`;

export const SelectedItems = styled.div`
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 16px;
`;

export const SelectedItemsList = styled.div`
  width: 100%;
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(3, minmax(190px, 1fr));
`;

export const SelectedItem = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  color: ${Palette.PrimaryGray._700};
  font-size: 12px;
  line-height: 32px;
  border: 1px solid ${Palette.PrimaryGray._200};
  background-color: #ffffff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
  height: 32px;
  padding-left: 8px;
`;
